module.exports = __webpack_public_path__ + "img/newSticker.84b530ee.png";